export default "__VITE_ASSET__RYlLbQS9__"